module.exports = '<svg width="52" height="32" viewBox="0 0 52 32"><path d="M44 2v28a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2zM25.992.588a1.862 1.862 0 0 0-2.716 0l-2.712 2.836a2.07 2.07 0 0 0 0 2.84l9.372 9.796-9.252 9.676a2.065 2.065 0 0 0 0 2.836l2.716 2.844c.752.78 1.964.78 2.716 0L39.44 17.488a2.075 2.075 0 0 0 0-2.844L25.992.588zm-20 0a1.862 1.862 0 0 0-2.716 0L.564 3.424a2.07 2.07 0 0 0 0 2.84l9.372 9.796-9.252 9.676a2.065 2.065 0 0 0 0 2.836L3.4 31.416c.752.78 1.964.78 2.716 0L19.44 17.488a2.075 2.075 0 0 0 0-2.844L5.992.588z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/next-3.js
// module id = 1305
// module chunks = 14